export default class DismissWormHornCommand {
	static protocol = {}
	constructor() {}
}
